import { useState, useEffect } from "react";

const KEY = "gif_search_age_gate";
const TTL_MS = 365 * 24 * 60 * 60 * 1000;

function readStored(): boolean {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const { accepted, ts } = JSON.parse(raw);
    return !!accepted && Date.now() - ts < TTL_MS;
  } catch {
    return false;
  }
}

export function useAgeGate() {
  const [accepted, setAccepted] = useState<boolean>(() => readStored());

  function accept() {
    const record = { accepted: true, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(record));
    setAccepted(true);
  }

  function revoke() {
    localStorage.removeItem(KEY);
    setAccepted(false);
  }

  // Re-check on visibility change (tab focus) in case localStorage was cleared.
  useEffect(() => {
    function onVisible() {
      if (document.visibilityState === "visible") {
        setAccepted(readStored());
      }
    }
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  return { accepted, accept, revoke };
}
